module.exports = "<div class=\"inhalt\">\n  <h1 class=\"oben\">Kontaktformular</h1><br />\n  <iframe class=\"kontakt\" src=\"../../assets/includes/kontakt.html\" frameborder=\"0\" scrolling=\"no\"></iframe>\n  <app-footer></app-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/kontakt/kontakt.component.html
// module id = ../../../../../src/app/kontakt/kontakt.component.html
// module chunks = main